'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'knife-kitchen';
var width = 576;
var height = 512;
var aliases = [128298];
var unicode = 'f6f5';
var svgPathData = 'M480 0L278.6 201.4 392.5 315.2 448 272l0-64L568 88 480 0zM416 144a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm72-72a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM400 368l-34.6-34.6-33.9 33.9c-11.7 10.1-26.1 21.7-42.8 33.2C240.4 434 178.1 464 112 464c-9 0-17.7-.8-25.9-2.2L256 291.9l33.9-33.9L256 224l-33.9 33.9L35.2 444.8 0 480s18 12 46.6 21.3C64.7 507.2 87.2 512 112 512c110 0 204.9-68.1 253.5-110.6c4.4-3.8 8.4-7.5 12-10.9C392 377 400 368 400 368z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faKnifeKitchen = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;